module.exports = __webpack_public_path__ + "static/mr-press-17-ff34fc18a68f171ba3a88beabc07b2ec.jpg";